import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useLocalePath, useRuntimeConfig } from '#imports'
import useAuth from '~/composables/auth/useAuth'

export default defineNuxtRouteMiddleware(async () => {
  const { appEnv } = useRuntimeConfig().public

  // SSR skip in dev mode
  if (process.server && appEnv !== 'production') {
    return
  }

  const localePath = useLocalePath()
  const { isAuthenticated, verifyToken } = useAuth()

  if (isAuthenticated.value) {
    return navigateTo(localePath('/account'))
  }

  await verifyToken()

  if (isAuthenticated.value) {
    return navigateTo(localePath('/account'))
  }
})
